import { render, staticRenderFns } from "./EventsView.vue?vue&type=template&id=320e0333&scoped=true&"
import script from "./EventsView.vue?vue&type=script&lang=js&"
export * from "./EventsView.vue?vue&type=script&lang=js&"
import style0 from "./EventsView.vue?vue&type=style&index=0&id=320e0333&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320e0333",
  null
  
)

export default component.exports